import { render, staticRenderFns } from "./ItemResolution.vue?vue&type=template&id=8e932c90&"
import script from "./ItemResolution.vue?vue&type=script&lang=js&"
export * from "./ItemResolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports